import { render, staticRenderFns } from "./TelefoneInput.vue?vue&type=template&id=55fd3fb2&scoped=true"
import script from "./TelefoneInput.vue?vue&type=script&lang=js"
export * from "./TelefoneInput.vue?vue&type=script&lang=js"
import style0 from "./TelefoneInput.vue?vue&type=style&index=0&id=55fd3fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fd3fb2",
  null
  
)

export default component.exports